import React from "react";
// import { Done, DoneAll } from "@mui/icons-material";
import LazyLoad from "react-lazy-load";
// import ReplyIcon from "@mui/icons-material/Reply";
// import DeleteIcon from "@mui/icons-material/Delete";
import classes from "./audiencePictureMessage.module.scss";

const AudiencePictureMessage = ({
  chat,
  //   reply,
  //   deleteMessage,
  doc,
  //   userId,
  imgSrc,
}) => {
  //   const owner = parseInt(userId) === parseInt(chat.user_id);

  const download = (file) => {
    // const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = `${chat.file}`;
    link.target = "_blank";
    link.setAttribute("download", chat.file.split("/").slice(-1)[0]);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div key={chat.key} className={classes.mainContainer}>
      <div className={classes.messageContainer}>
        <div onClick={download}>
          <p>{chat.message}</p>
          <LazyLoad height={200} offsetVertical={200}>
            <img
              style={{ width: 200, height: 200, borderRadius: 8 }}
              src={chat.file}
              alt="downloadImage"
            />
          </LazyLoad>

          {doc}
        </div>
      </div>
      <img className={classes.userImg} src={imgSrc} alt="userImg" />

      {/* <time>{chat.created_at}</time>
      {owner ? (
        <span className="seen">{chat.seen ? <DoneAll /> : <Done />}</span>
      ) : null}
      {owner ? (
        <div className="control_message" style={{ display: "inline" }}>
          <ReplyIcon className="reply_message" onClick={() => reply(chat)} />
          <DeleteIcon
            className="delete_message"
            onClick={() => deleteMessage(chat)}
          />
        </div>
      ) : (
        <div
          className="control_message"
          style={{ display: "inline", float: "left" }}
        >
          <ReplyIcon className="reply_message" onClick={() => reply(chat)} />
        </div>
      )} */}
    </div>
  );
};

export default AudiencePictureMessage;
